import './style.scss';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';

type GaugeProps = {
  currentPage: number;
};
export const Gauge = ({ currentPage }: GaugeProps) => {
  const data = CreateAccountPageGaugeData;
  return (
    <div className="content">
      <div className="top">
        <div className="count">{`${currentPage}/${data.length}`}</div>
        <div className="labelTitle">{data[currentPage - 1].label}</div>
      </div>
      <div className="gauge">
        <div
          className="left"
          style={{
            width: `${(currentPage / data.length) * 100}%`,
          }}
        ></div>
        <div
          className="right"
          style={{
            width: `${((data.length - currentPage) / data.length) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
};

export const GaugeSP = ({ currentPage }: GaugeProps) => {
  if (currentPage === 0) return null;

  const data = CreateAccountPageGaugeData;
  return (
    <div className="contentSP">
      <div className="top">
        <div className="count">{`${currentPage}/${data.length}`}</div>
        <div className="labelTitle">{data[currentPage - 1].label}</div>
      </div>
      <div className="gauge">
        <div
          className="left"
          style={{
            width: `${(currentPage / data.length) * 100}%`,
          }}
        ></div>
        <div
          className="right"
          style={{
            width: `${((data.length - currentPage) / data.length) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
};

const CreateAccountPageGaugeData = [
  {
    path: CustomerPagePath.AddvanceQuestion,
    label: '事前質問',
  },
  {
    path: CustomerPagePath.ConsentSecurities,
    label: 'FPG証券に対する同意事項',
  },
  {
    path: CustomerPagePath.ConsentTrust,
    label: 'FPG信託に対する承諾事項',
  },
  {
    path: CustomerPagePath.CustomerInfo,
    label: 'お客様情報',
  },
  {
    path: CustomerPagePath.DepositAccount,
    label: '指定預金口座情報',
  },
  {
    path: CustomerPagePath.Employment,
    label: 'お勤め先情報',
  },
  {
    path: CustomerPagePath.InvestmentInfo,
    label: '投資情報',
  },
  {
    path: CustomerPagePath.RequestConfirm,
    label: '入力確認',
  },
  {
    path: CustomerPagePath.RequestComplete,
    label: '口座開設申込完了',
  },
];

export const getGaugeValue = (path: string) => {
  const data = CreateAccountPageGaugeData;
  const index = data.findIndex((item) => item.path === path);
  return index + 1;
};
